<template>
  <div class="container text-center py-20">
    <IconsEvangelistIcon
      class="mx-auto w-12 h-12 opacity-30 rotating-object-fast"
    />
  </div>
</template>
